(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Theme
//
// ------------------------------------

(function($) {

	if (typeof window.TheChurchCo_FlyIO == 'undefined') window.TheChurchCo_FlyIO = {};

	TheChurchCo_FlyIO = {

		// ------------------------------------
		// Init
		// ------------------------------------

		init: function(){

            if($('[data-domain-mapping]').length <= 0) return;

            // Check Domains
            $('[data-domain-mapping-domain]').each(TheChurchCo_FlyIO.checkDomain)

		},

		checkDomain: function(){

            var $element = $(this);
            var domain = $element.attr('data-domain-mapping-domain');

			// Make the Request.			
			var payload = {};
			payload.domain = $element.attr('data-domain-mapping-domain'); 

			// Send Data
			$.ajax({
	    		url: '/api/v1/domains/ssl/check',
	    		type: 'POST',
	    		data: payload,
	    		success: function(data, textStatus, jqXHR){

                    if(data.error){
                        console.log("Error : ", payload.domain);
                        return;
                    }

                    // Show Status: We only get here if the domain is in Fly.
                    if(data.data.app.certificate){
                        $element.text(data.data.app.certificate.clientStatus)
                    }

                    
	    		},
	    		error: function(jqXHR, textStatus, errorThrown){
					console.log("Error : ", payload.domain);
	    		}

	    	});


		},


	};

	module.exports = TheChurchCo_FlyIO;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/flyio-ssl.js","/modules")